var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{attrs:{"title":"システムエラー","lead":"サーバでエラーが発生しました"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n    しばらく時間を置いてから、もう一度やり直してください。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }